// // import { Testimonial } from '@/components'
// import Hero from './Hero'
// import Features1 from './Features1'
// import Features5 from './Features5'
// import Features4 from './Features4'
// import Features3 from './Features3'

// import { features } from './data'
// import FeedBack from './Feedback'
// import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar'
// import Footer1 from '../../components/common/Footer1'
// import { useLayoutEffect } from 'react'


// const Landing = () => {
// 	useLayoutEffect(()=>{
// 		window.scrollTo(0,0)
// 	},[])
// 	return (
// 		<>
// 		<LayoutsNavbar/>
// 			<Hero />
// 			<Features1 />
// 			<section>
// 				<Features3 />
// 				<Features4 />
// 				{/* <Features5 /> */}
// 			</section>
// 			<FeedBack />
// 			{/*	<Testimonial />*/}

// 			<Footer1 /> 
// 		</>
// 	)
// }

// export default Landing




import React, { useState, useEffect } from 'react';
import {
	ChevronDown,
	MessageSquare,
	BarChart3,
	Shield,
	Zap,
	Star,
	Check,
	Menu,
	X,
	ArrowRight,
	Users,
	Clock,
	TrendingUp,
	Lock,
	Globe,
	Smartphone,
	CheckCircle,
	ArrowLeft
} from 'lucide-react';
import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'

import avatar1 from '../../5pageAssets/images/avatars/img-1.jpg'
import avatar2 from '../../5pageAssets/images/avatars/img-2.jpg'
import avatar3 from '../../5pageAssets/images/avatars/img-3.jpg'

import google from '../../5pageAssets/images/brands/google.svg'
import amazon from '../../5pageAssets/images/brands/amazon.svg'
import lenovo from '../../5pageAssets/images/brands/lenovo.svg'
import Footer1 from '../../components/common/Footer1';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
const LandingPage = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [currentTestimonial, setCurrentTestimonial] = useState(0);
	const token = Cookies.get("token");
	const [isVisible, setIsVisible] = useState({});

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
					}
				});
			},
			{ threshold: 0.1 }
		);

		const elements = document.querySelectorAll('.animate-on-scroll');
		elements.forEach((el) => observer.observe(el));

		return () => observer.disconnect();
	}, []);

	const testimonials = [
		{
			name: "Sarah Johnson",
			role: "Marketing Director",
			company: "TechCorp",
			avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face",
			content: "This platform revolutionized our customer communication. We've seen a 300% increase in response rates across all social channels.",
			rating: 5
		},
		{
			name: "Michael Chen",
			role: "CEO",
			company: "StartupXYZ",
			avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face",
			content: "The automation features saved us countless hours. Our team can now focus on strategy while the platform handles routine conversations.",
			rating: 5
		},
		{
			name: "Emma Rodriguez",
			role: "Social Media Manager",
			company: "BrandCo",
			avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face",
			content: "Managing multiple platforms was a nightmare until we found this solution. Now everything is centralized and automated.",
			rating: 5
		}
	];

	const features = [
		{
			icon: <Zap className="w-6 h-6" />,
			title: "Smart Automation",
			description: "AI-powered responses that learn from your conversations and handle routine inquiries automatically."
		},
		{
			icon: <MessageSquare className="w-6 h-6" />,
			title: "Multi-Platform Integration",
			description: "Connect Instagram, Facebook, and WhatsApp in one unified dashboard for seamless communication."
		},
		{
			icon: <BarChart3 className="w-6 h-6" />,
			title: "Advanced Analytics",
			description: "Get detailed insights into your customer interactions, response times, and engagement metrics."
		},
		{
			icon: <Shield className="w-6 h-6" />,
			title: "Enterprise Security",
			description: "Bank-level encryption with 2FA authentication to keep your business communications secure."
		},
		{
			icon: <Users className="w-6 h-6" />,
			title: "Team Collaboration",
			description: "Assign conversations to team members and collaborate in real-time with internal notes."
		},
		{
			icon: <Clock className="w-6 h-6" />,
			title: "24/7 Support",
			description: "Round-the-clock customer support with priority assistance for business-critical issues."
		}
	];

	const pricingPlans = [
		{
			name: "Starter",
			price: "$29",
			period: "/month",
			description: "Perfect for small businesses getting started",
			features: [
				"Up to 1,000 conversations/month",
				"2 social platform connections",
				"Basic automation",
				"Email support",
				"Basic analytics"
			],
			popular: false
		},
		{
			name: "Professional",
			price: "$79",
			period: "/month",
			description: "Ideal for growing businesses",
			features: [
				"Up to 10,000 conversations/month",
				"All platform integrations",
				"Advanced automation & AI",
				"Priority support",
				"Advanced analytics",
				"Team collaboration",
				"Custom workflows"
			],
			popular: true
		},
		{
			name: "Enterprise",
			price: "$199",
			period: "/month",
			description: "For large organizations",
			features: [
				"Unlimited conversations",
				"All features included",
				"Dedicated account manager",
				"Custom integrations",
				"Advanced security features",
				"SLA guarantee",
				"Training & onboarding"
			],
			popular: false
		}
	];

	const SecuritySatisfactionSVG = () => (
		<svg viewBox="0 0 400 300" className="w-full h-full">
			{/* Background circles */}
			<circle cx="200" cy="150" r="140" fill="#50B5FF" fillOpacity="0.05" />
			<circle cx="200" cy="150" r="100" fill="#50B5FF" fillOpacity="0.1" />
			<circle cx="200" cy="150" r="60" fill="#50B5FF" fillOpacity="0.15" />

			{/* Central shield */}
			<g transform="translate(200, 150)">
				<path
					d="M-20,-30 L20,-30 L20,-10 L25,0 L20,10 L20,30 L-20,30 L-20,10 L-25,0 L-20,-10 Z"
					fill="#50B5FF"
					className="animate-pulse"
				/>
				<path
					d="M-10,-15 L-5,-10 L10,-20"
					stroke="white"
					strokeWidth="3"
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>

			{/* Floating security icons */}
			<g className="animate-bounce" style={{ animationDelay: '0s', animationDuration: '3s' }}>
				<circle cx="120" cy="80" r="25" fill="white" stroke="#50B5FF" strokeWidth="2" />
				<path d="M110,75 L115,80 L125,70" stroke="#50B5FF" strokeWidth="2" fill="none" strokeLinecap="round" />
			</g>

			<g className="animate-bounce" style={{ animationDelay: '1s', animationDuration: '3s' }}>
				<circle cx="280" cy="100" r="25" fill="white" stroke="#50B5FF" strokeWidth="2" />
				<rect x="272" y="92" width="16" height="12" rx="2" fill="none" stroke="#50B5FF" strokeWidth="2" />
				<path d="M276,92 V88 A4,4 0 0,1 284,88 V92" fill="none" stroke="#50B5FF" strokeWidth="2" />
			</g>

			<g className="animate-bounce" style={{ animationDelay: '2s', animationDuration: '3s' }}>
				<circle cx="140" cy="220" r="25" fill="white" stroke="#50B5FF" strokeWidth="2" />
				<circle cx="140" cy="220" r="8" fill="none" stroke="#50B5FF" strokeWidth="2" />
				<path d="M132,220 L148,220 M140,212 L140,228" stroke="#50B5FF" strokeWidth="2" />
			</g>

			<g className="animate-bounce" style={{ animationDelay: '0.5s', animationDuration: '3s' }}>
				<circle cx="260" cy="200" r="25" fill="white" stroke="#50B5FF" strokeWidth="2" />
				<path d="M252,195 L252,205 L268,205 L268,195 M256,195 V191 A4,4 0 0,1 264,191 V195"
					fill="none" stroke="#50B5FF" strokeWidth="2" />
			</g>

			{/* Satisfaction metrics */}
			<g transform="translate(60, 50)">
				<rect x="0" y="0" width="80" height="40" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="1" />
				<text x="40" y="15" textAnchor="middle" fontSize="10" fill="#50B5FF" fontWeight="bold">99.9%</text>
				<text x="40" y="28" textAnchor="middle" fontSize="8" fill="#6b7280">Uptime</text>
			</g>

			<g transform="translate(260, 50)">
				<rect x="0" y="0" width="80" height="40" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="1" />
				<text x="40" y="15" textAnchor="middle" fontSize="10" fill="#50B5FF" fontWeight="bold">4.9/5</text>
				<text x="40" y="28" textAnchor="middle" fontSize="8" fill="#6b7280">Security Rating</text>
			</g>

			<g transform="translate(160, 260)">
				<rect x="0" y="0" width="80" height="40" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="1" />
				<text x="40" y="15" textAnchor="middle" fontSize="10" fill="#50B5FF" fontWeight="bold">100K+</text>
				<text x="40" y="28" textAnchor="middle" fontSize="8" fill="#6b7280">Protected Users</text>
			</g>

			{/* Connection lines */}
			<path d="M140,105 Q200,120 200,130" stroke="#50B5FF" strokeWidth="1" fill="none" opacity="0.3" strokeDasharray="5,5" />
			<path d="M260,125 Q230,140 220,150" stroke="#50B5FF" strokeWidth="1" fill="none" opacity="0.3" strokeDasharray="5,5" />
			<path d="M165,220 Q180,180 190,160" stroke="#50B5FF" strokeWidth="1" fill="none" opacity="0.3" strokeDasharray="5,5" />
			<path d="M240,200 Q220,180 210,160" stroke="#50B5FF" strokeWidth="1" fill="none" opacity="0.3" strokeDasharray="5,5" />
		</svg>
	);

	useEffect(() => {
		const interval = setInterval(() => {
			nextTestimonial();
		}, 6000);
		return () => clearInterval(interval);
	}, []);

	const nextTestimonial = () => {
		setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
	};

	const prevTestimonial = () => {
		setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
	};

	const handlerCalendly = () => {
		// Check if Calendly already loaded to prevent duplicates
		if (!document.getElementById('calendly-style')) {
			const link = document.createElement('link');
			link.id = 'calendly-style';
			link.rel = 'stylesheet';
			link.href = 'https://assets.calendly.com/assets/external/widget.css';
			document.head.appendChild(link);
		}

		if (!document.getElementById('calendly-script')) {
			const script = document.createElement('script');
			script.id = 'calendly-script';
			script.src = 'https://assets.calendly.com/assets/external/widget.js';
			script.onload = () => {
				openCalendlyPopup(); // Open only after script loads
			};
			document.head.appendChild(script);
		} else {
			openCalendlyPopup(); // Already loaded
		}
	};

	const openCalendlyPopup = () => {
		if (window.Calendly) {
			window.Calendly.initPopupWidget({
				url: 'https://calendly.com/chatinject/inquiry', // Replace with your actual Calendly URL
			});
		}
	};
	return (
		<div>
			<LayoutsNavbar />

			<div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden mt-[86px]">
				<section className="relative pt-20 pb-16 overflow-hidden">
					<div className="absolute inset-0 bg-gradient-to-br from-[#50B5FF]/5 to-purple-50"></div>
					<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8  ">
						<div className="grid lg:grid-cols-2 gap-12 items-center">
							<div className="space-y-8">
								<div className="space-y-4">
									<div className="inline-flex items-center bg-[#50B5FF]/10 text-[#50B5FF] px-4 py-2 rounded-full text-sm font-medium">
										<Zap className="w-4 h-4 mr-2" />
										New: AI-Powered Automation
									</div>
									<h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
										Unify Your Business
										<span className="block bg-gradient-to-r from-[#50B5FF] via-blue-500 to-purple-500 bg-clip-text text-transparent leading-tight"> Communications</span>
									</h1>
									<p className="text-xl text-gray-600 leading-relaxed">
										Connect Instagram, Facebook, and WhatsApp in one powerful platform.
										Automate responses, manage profiles, and get insights that drive growth.
									</p>
								</div>

								<div className="flex flex-col sm:flex-row gap-4">
									<Link to={token ? '/dashboards' : 'auth/sign-in'} className="bg-[#50B5FF] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#3A9EE8] transform hover:scale-105 transition-all duration-200 flex items-center justify-center">
										{token ? "Dashboard" : "Start Free"}
										<ArrowRight className="w-5 h-5 ml-2" />
									</Link>
									<Link to={'pages/documention/Introduction'} className="border-2 border-[#50B5FF] text-[#50B5FF] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#50B5FF] hover:text-white flex items-center justify-center transition-all duration-200">
										Documention
									</Link>
								</div>

								<div className="flex items-center space-x-8 pt-4">
									<div className="text-center">
										<div className="text-2xl font-bold text-gray-900">50K+</div>
										<div className="text-sm text-gray-600">Active Users</div>
									</div>
									<div className="text-center">
										<div className="text-2xl font-bold text-gray-900">1M+</div>
										<div className="text-sm text-gray-600">Messages Processed</div>
									</div>
									<div className="text-center">
										<div className="text-2xl font-bold text-gray-900">99.9%</div>
										<div className="text-sm text-gray-600">Uptime</div>
									</div>
								</div>
							</div>

							{/* <div className="relative">
							<div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
								<div className="space-y-6">
									<div className="flex items-center justify-between">
										<h3 className="text-lg font-semibold text-gray-900">Platform Integrations</h3>
										<div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
									</div>

									<div className="space-y-4">
										<div className="flex items-center justify-between p-4 bg-gradient-to-r from-pink-50 to-purple-50 rounded-lg border">
											<div className="flex items-center space-x-3">
												<div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white font-bold">IG</div>
												<div>
													<div className="font-medium text-gray-900">Instagram</div>
													<div className="text-sm text-gray-500">Connected</div>
												</div>
											</div>
											<div className="text-green-500">✓</div>
										</div>

										<div className="flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border">
											<div className="flex items-center space-x-3">
												<div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold">f</div>
												<div>
													<div className="font-medium text-gray-900">Facebook</div>
													<div className="text-sm text-gray-500">Connected</div>
												</div>
											</div>
											<div className="text-green-500">✓</div>
										</div>

										<div className="flex items-center justify-between p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border">
											<div className="flex items-center space-x-3">
												<div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center text-white font-bold">W</div>
												<div>
													<div className="font-medium text-gray-900">WhatsApp</div>
													<div className="text-sm text-gray-500">Connected</div>
												</div>
											</div>
											<div className="text-green-500">✓</div>
										</div>
									</div>

									<div className="pt-4 border-t border-gray-100">
										<div className="flex items-center justify-between text-sm">
											<span className="text-gray-600">Active Conversations</span>
											<span className="font-semibold text-[#50B5FF]">24</span>
										</div>
										<div className="flex items-center justify-between text-sm mt-2">
											<span className="text-gray-600">Response Rate</span>
											<span className="font-semibold text-green-500">98.5%</span>
										</div>
									</div>
								</div>
							</div>
						</div> */}

							<div className={`relative transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
								<div className="relative">
									{/* Main dashboard mockup */}
									<div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 shadow-2xl">
										<div className="flex items-center justify-between mb-6">
											<div className="flex space-x-2">
												<div className="w-3 h-3 bg-red-400 rounded-full"></div>
												<div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
												<div className="w-3 h-3 bg-green-400 rounded-full"></div>
											</div>
											<div className="text-sm text-slate-400">Communication Hub</div>
										</div>

										{/* Dashboard content */}
										<div className="space-y-4">
											<div className="flex items-center justify-between p-4 bg-gradient-to-r from-pink-50 to-purple-50 rounded-lg border">
												<div className="flex items-center space-x-3">
													<div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white font-bold">IG</div>
													<div>
														<div className="font-medium text-gray-900">Instagram</div>
														<div className="text-sm text-gray-500">1,234 messages</div>
													</div>
												</div>
												<div className="text-green-500">+12%</div>
											</div>
											<div className="flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border">
												<div className="flex items-center space-x-3">
													<div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold">f</div>
													<div>
														<div className="font-medium text-gray-900">Facebook</div>
														<div className="text-sm text-gray-500">856 messages</div>
													</div>

												</div>
												<div className="text-green-500">+8%</div>
											</div>
											<div className="flex items-center justify-between p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border">
												<div className="flex items-center space-x-3">
													<div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center text-white font-bold">W</div>
													<div>
														<div className="font-medium text-gray-900">WhatsApp</div>
														<div className="text-slate-400 text-sm">2,103 messages</div>
													</div>
												</div>
												<div className="text-green-500">+10%</div>
											</div>
										</div>

										{/* Mini chart */}
										<div className="mt-6 p-4 bg-white/5 rounded-xl border border-white/10">
											<div className="flex items-center justify-between mb-3">
												<span className="font-medium">Performance</span>
												<BarChart3 className="w-4 h-4 text-[#50B5FF]" />
											</div>
											<div className="flex items-end space-x-2 h-16">
												<div className="bg-gradient-to-t from-[#50B5FF] to-blue-400 rounded-sm flex-1 h-8"></div>
												<div className="bg-gradient-to-t from-[#50B5FF] to-blue-400 rounded-sm flex-1 h-12"></div>
												<div className="bg-gradient-to-t from-[#50B5FF] to-blue-400 rounded-sm flex-1 h-16"></div>
												<div className="bg-gradient-to-t from-[#50B5FF] to-blue-400 rounded-sm flex-1 h-10"></div>
												<div className="bg-gradient-to-t from-[#50B5FF] to-blue-400 rounded-sm flex-1 h-14"></div>
											</div>
										</div>
									</div>

									{/* Floating elements */}
									<div className="absolute -top-6 -right-6 bg-gradient-to-r from-[#50B5FF] to-purple-600 p-4 rounded-2xl shadow-xl animate-bounce">
										<Shield className="w-6 h-6 text-white" />
									</div>

									<div className="absolute -bottom-6 -left-6 bg-gradient-to-r from-green-500 to-emerald-600 p-4 rounded-2xl shadow-xl animate-pulse">
										<CheckCircle className="w-6 h-6 text-white" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Features Section */}
				<section id="features" className="py-20 bg-gray-50">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="text-center mb-16">
							<div className="inline-flex items-center bg-[#50B5FF]/10 text-[#50B5FF] px-4 py-2 rounded-full text-sm font-medium mb-4">
								Features
							</div>
							<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
								Everything you need to scale your communications
							</h2>
							<p className="text-xl text-gray-600 max-w-3xl mx-auto">
								Powerful features designed to help you connect with customers across all platforms
							</p>
						</div>

						<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
							{features.map((feature, index) => (
								<div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-lg transition-shadow duration-200">
									<div className="w-12 h-12 bg-[#50B5FF]/10 rounded-lg flex items-center justify-center text-[#50B5FF] mb-6">
										{feature.icon}
									</div>
									<h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
									<p className="text-gray-600 leading-relaxed">{feature.description}</p>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Platform Integration Showcase */}
				<section className="py-20 mt-5">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid lg:grid-cols-2 gap-12 items-center">
							<div className="space-y-8">
								<div className="space-y-4">
									<div className="inline-flex items-center bg-[#50B5FF]/10 text-[#50B5FF] px-4 py-2 rounded-full text-sm font-medium">
										Integrations
									</div>
									<h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
										Connect all your favorite platforms
									</h2>
									<p className="text-xl text-gray-600">
										Seamlessly integrate with the platforms your customers use most
									</p>
								</div>

								<div className="space-y-6">
									<div className="flex items-center space-x-4">
										<div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
											<Check className="w-5 h-5 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900">Unified Inbox</div>
											<div className="text-gray-600">All messages in one place</div>
										</div>
									</div>

									<div className="flex items-center space-x-4">
										<div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
											<Check className="w-5 h-5 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900">Real-time Sync</div>
											<div className="text-gray-600">Instant message synchronization</div>
										</div>
									</div>

									<div className="flex items-center space-x-4">
										<div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
											<Check className="w-5 h-5 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900">Smart Routing</div>
											<div className="text-gray-600">Auto-assign to the right team member</div>
										</div>
									</div>
								</div>
							</div>

							<div className="relative">
								<div className="grid grid-cols-2 gap-6">
									<div className="space-y-6">
										<div className="bg-gradient-to-br from-purple-500 to-pink-500 p-6 rounded-xl text-white shadow-lg transform rotate-3 hover:rotate-0 transition-transform duration-200">
											<div className="text-2xl font-bold mb-2">Instagram</div>
											<div className="text-purple-100">Direct messages, Stories, Comments</div>
										</div>
										<div className="bg-gradient-to-br from-green-500 to-emerald-500 p-6 rounded-xl text-white shadow-lg transform -rotate-3 hover:rotate-0 transition-transform duration-200">
											<div className="text-2xl font-bold mb-2">WhatsApp</div>
											<div className="text-green-100">Business API, Automated responses</div>
										</div>
									</div>
									<div className="space-y-6 pt-12">
										<div className="bg-gradient-to-br from-blue-500 to-indigo-500 p-6 rounded-xl text-white shadow-lg transform rotate-2 hover:rotate-0 transition-transform duration-200">
											<div className="text-2xl font-bold mb-2">Facebook</div>
											<div className="text-blue-100">Messenger, Page messages</div>
										</div>
										<div className="bg-gradient-to-br from-[#50B5FF] to-cyan-500 p-6 rounded-xl text-white shadow-lg transform -rotate-2 hover:rotate-0 transition-transform duration-200">
											<div className="text-2xl font-bold mb-2">More Soon</div>
											<div className="text-blue-100">Telegram, LinkedIn, Twitter</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section id="testimonials" className="py-20 bg-gray-50 overflow-hidden">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid xl:grid-cols-4 lg:grid-cols-3 gap-8">
							{/* Left Content */}
							<div className="lg:col-span-1">
								<div className="inline-flex items-center bg-[#50B5FF]/10 text-[#50B5FF] px-4 py-2 rounded-full text-sm font-medium mb-4">
									Feedback
								</div>
								<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
									What people say
								</h2>
								<p className="text-gray-600 mb-8">
									Few valuable words from our customers
								</p>

								{/* Navigation Buttons */}
								<div className="flex gap-4">
									<button
										onClick={prevTestimonial}
										className="w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center text-gray-600 hover:border-[#50B5FF] hover:text-[#50B5FF] transition-all duration-300"
									>
										<ArrowLeft className="w-5 h-5" />
									</button>
									<button
										onClick={nextTestimonial}
										className="w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center text-gray-600 hover:border-[#50B5FF] hover:text-[#50B5FF] transition-all duration-300"
									>
										<ArrowRight className="w-5 h-5" />
									</button>
								</div>
							</div>

							{/* Testimonial Content */}
							<div className="lg:col-span-2 xl:col-span-3">
								<div className="relative">
									<div className="bg-white rounded-2xl border border-gray-100 p-8 lg:p-12 relative overflow-hidden">
										{/* Background Pattern */}
										<div className="absolute top-0 right-0 w-32 h-32 opacity-5">
											<div className="w-full h-full bg-[#50B5FF] transform rotate-12 rounded-3xl"></div>
										</div>

										{/* Stars */}
										<div className="flex mb-6">
											{[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
												<Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
											))}
										</div>

										{/* Quote */}
										<blockquote className="text-xl lg:text-2xl text-gray-700 leading-relaxed mb-8 relative">
											<span className="text-6xl text-[#50B5FF]/20 absolute -top-4 -left-2">"</span>
											{testimonials[currentTestimonial].content}
										</blockquote>

										{/* Author Info */}
										<div className="flex items-center justify-between">
											<div className="flex items-center space-x-4">
												<img
													src={testimonials[currentTestimonial].avatar}
													alt={testimonials[currentTestimonial].name}
													className="w-16 h-16 rounded-full border-4 border-white shadow-lg"
												/>
												<div>
													<div className="font-semibold text-gray-900 text-lg">
														{testimonials[currentTestimonial].name}
													</div>
													<div className="text-gray-600">
														{testimonials[currentTestimonial].role}
													</div>
													<div className="text-[#50B5FF] font-medium">
														{testimonials[currentTestimonial].company}
													</div>
												</div>
											</div>

											{/* Company Logo */}
											<div className="hidden sm:block">
												<img
													src={testimonials[currentTestimonial].logo}
													alt="Company logo"
													className="h-8 opacity-60"
												/>
											</div>
										</div>
									</div>

									{/* Dots Indicator */}
									<div className="flex justify-center mt-8 space-x-3">
										{testimonials.map((_, index) => (
											<button
												key={index}
												onClick={() => setCurrentTestimonial(index)}
												className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentTestimonial
													? 'bg-[#50B5FF] w-8'
													: 'bg-gray-300 hover:bg-gray-400'
													}`}
											/>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>



				{/* Pricing Section */}
				{/* <section id="pricing" className="py-20">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="text-center mb-16">
							<div className="inline-flex items-center bg-[#50B5FF]/10 text-[#50B5FF] px-4 py-2 rounded-full text-sm font-medium mb-4">
								Pricing
							</div>
							<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
								Choose the perfect plan for your business
							</h2>
							<p className="text-xl text-gray-600">
								Flexible pricing that grows with your business needs
							</p>
						</div>

						<div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
							{pricingPlans.map((plan, index) => (
								<div
									key={index}
									className={`relative bg-white rounded-2xl shadow-lg border-2 p-8 ${plan.popular
										? 'border-[#50B5FF] transform scale-105'
										: 'border-gray-100 hover:border-[#50B5FF]/20'
										} transition-all duration-200`}
								>
									{plan.popular && (
										<div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
											<div className="bg-[#50B5FF] text-white px-6 py-2 rounded-full text-sm font-medium">
												Most Popular
											</div>
										</div>
									)}

									<div className="text-center mb-8">
										<h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
										<p className="text-gray-600 mb-4">{plan.description}</p>
										<div className="flex items-baseline justify-center">
											<span className="text-4xl font-bold text-gray-900">{plan.price}</span>
											<span className="text-gray-600 ml-1">{plan.period}</span>
										</div>
									</div>

									<ul className="space-y-4 mb-8">
										{plan.features.map((feature, featureIndex) => (
											<li key={featureIndex} className="flex items-center">
												<Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
												<span className="text-gray-700">{feature}</span>
											</li>
										))}
									</ul>

									<button
										className={`w-full py-3 px-6 rounded-lg font-semibold transition-all duration-200 ${plan.popular
											? 'bg-[#50B5FF] text-white hover:bg-[#3A9EE8] transform hover:scale-105'
											: 'bg-gray-100 text-gray-900 hover:bg-gray-200'
											}`}
									>
										Get Started
									</button>
								</div>
							))}
						</div>
					</div>
				</section> */}
				{/* Security Section */}
				<section className="py-20 bg-gray-50 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid lg:grid-cols-2 gap-12 items-center">
							<div className="space-y-8">
								<div className="space-y-4">
									<div className="inline-flex items-center bg-[#50B5FF]/10 text-[#50B5FF] px-4 py-2 rounded-full text-sm font-medium">
										Security
									</div>
									<h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
										Enterprise-grade security you can trust
									</h2>
									<p className="text-xl text-gray-600">
										Your data is protected with the highest security standards
									</p>
								</div>

								<div className="space-y-6">
									<div className="flex items-start space-x-4">
										<div className="w-8 h-8 bg-[#50B5FF] rounded-full flex items-center justify-center mt-1">
											<Lock className="w-4 h-4 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900 mb-1">Two-Factor Authentication</div>
											<div className="text-gray-600">Add an extra layer of security to your account with SMS and app-based 2FA</div>
										</div>
									</div>

									<div className="flex items-start space-x-4">
										<div className="w-8 h-8 bg-[#50B5FF] rounded-full flex items-center justify-center mt-1">
											<Shield className="w-4 h-4 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900 mb-1">End-to-End Encryption</div>
											<div className="text-gray-600">All communications are encrypted with AES-256 in transit and at rest</div>
										</div>
									</div>

									<div className="flex items-start space-x-4">
										<div className="w-8 h-8 bg-[#50B5FF] rounded-full flex items-center justify-center mt-1">
											<Globe className="w-4 h-4 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900 mb-1">GDPR & SOC2 Compliant</div>
											<div className="text-gray-600">Full compliance with international data protection and security frameworks</div>
										</div>
									</div>

									<div className="flex items-start space-x-4">
										<div className="w-8 h-8 bg-[#50B5FF] rounded-full flex items-center justify-center mt-1">
											<CheckCircle className="w-4 h-4 text-white" />
										</div>
										<div>
											<div className="font-semibold text-gray-900 mb-1">Regular Security Audits</div>
											<div className="text-gray-600">Third-party security assessments and penetration testing</div>
										</div>
									</div>
								</div>

								{/* Trust Badges */}
								<div className="flex items-center space-x-6 pt-4">
									<div className="flex items-center space-x-2">
										<div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
											<CheckCircle className="w-5 h-5 text-green-600" />
										</div>
										<span className="text-sm font-medium text-gray-700">SOC 2 Type II</span>
									</div>
									<div className="flex items-center space-x-2">
										<div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
											<Shield className="w-5 h-5 text-blue-600" />
										</div>
										<span className="text-sm font-medium text-gray-700">ISO 27001</span>
									</div>
								</div>
							</div>

							{/* Security Visualization */}
							<div className="relative">
								<div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
									<div className="h-80">
										<SecuritySatisfactionSVG />
									</div>

									{/* Bottom Stats */}
									<div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-gray-100">
										<div className="text-center">
											<div className="text-2xl font-bold text-[#50B5FF]">99.9%</div>
											<div className="text-xs text-gray-600">Security Score</div>
										</div>
										<div className="text-center">
											<div className="text-2xl font-bold text-[#50B5FF]">0</div>
											<div className="text-xs text-gray-600">Data Breaches</div>
										</div>
										<div className="text-center">
											<div className="text-2xl font-bold text-[#50B5FF]">24/7</div>
											<div className="text-xs text-gray-600">Monitoring</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>



				{/* CTA Section */}
				<section className="py-20 bg-gradient-to-br from-[#50B5FF] to-purple-600">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
						<div className="max-w-3xl mx-auto space-y-8">
							<h2 className="text-3xl lg:text-5xl font-bold text-white leading-tight">
								Ready to transform your business communications?
							</h2>
							<p className="text-xl text-blue-100">
								Join thousands of businesses already using CommHub to streamline their customer interactions
							</p>

							<div className="flex flex-col sm:flex-row gap-4 justify-center">
								<button className="bg-white text-[#50B5FF] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-200 flex items-center justify-center">
									Start Free Trial
									<ArrowRight className="w-5 h-5 ml-2" />
								</button>
								<button
									className="group border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:bg-white"
									onClick={handlerCalendly}
								>
									<span className="group-hover:text-[#50B5FF] transition-colors duration-200">
										Schedule Demo
									</span>
								</button>
							</div>

							<div className="flex items-center justify-center space-x-8 text-blue-100">
								<div className="flex items-center space-x-2">
									<Check className="w-5 h-5" />
									<span>14-day free trial</span>
								</div>
								<div className="flex items-center space-x-2">
									<Check className="w-5 h-5" />
									<span>No credit card required</span>
								</div>
								<div className="flex items-center space-x-2">
									<Check className="w-5 h-5" />
									<span>Cancel anytime</span>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Footer */}
				{/* <footer className="bg-gray-900 text-white py-16">
					<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
						<div className="grid md:grid-cols-4 gap-8">
							<div className="space-y-4">
								<div className="flex items-center">
									<div className="w-8 h-8 bg-[#50B5FF] rounded-lg flex items-center justify-center">
										<MessageSquare className="w-5 h-5 text-white" />
									</div>
									<span className="ml-2 text-xl font-bold">Chatinject</span>
								</div>
								<p className="text-gray-400">
									The all-in-one platform for business communications across Instagram, Facebook, and WhatsApp.
								</p>
								<div className="flex space-x-4">
									<div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#50B5FF] cursor-pointer transition-colors">
										<span className="text-sm font-bold">f</span>
									</div>
									<div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#50B5FF] cursor-pointer transition-colors">
										<span className="text-sm font-bold">T</span>
									</div>
									<div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#50B5FF] cursor-pointer transition-colors">
										<span className="text-sm font-bold">Li</span>
									</div>
								</div>
							</div>

							<div>
								<h3 className="font-semibold mb-4">Product</h3>
								<ul className="space-y-2 text-gray-400">
									<li><a href="#" className="hover:text-white transition-colors">Features</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Integrations</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Pricing</a></li>
									<li><a href="#" className="hover:text-white transition-colors">API</a></li>
								</ul>
							</div>

							<div>
								<h3 className="font-semibold mb-4">Company</h3>
								<ul className="space-y-2 text-gray-400">
									<li><a href="#" className="hover:text-white transition-colors">About</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Careers</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
								</ul>
							</div>

							<div>
								<h3 className="font-semibold mb-4">Support</h3>
								<ul className="space-y-2 text-gray-400">
									<li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Documentation</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Status</a></li>
									<li><a href="#" className="hover:text-white transition-colors">Security</a></li>
								</ul>
							</div>
						</div>

						<div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
							<div className="text-gray-400 text-sm">
								© 2025 ChatInject. All rights reserved.
							</div>
							<div className="flex space-x-6 text-sm text-gray-400 mt-4 md:mt-0">
								<a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
								<a href="#" className="hover:text-white transition-colors">Terms of Service</a>
								<a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
							</div>
						</div>
					</div>
				</footer> */}

				<Footer1 />
			</div>
		</div>
	);
};

export default LandingPage;